
<div class="box">
   <ng-container *ngFor="let shipping of shippings$ | async; let index = index;">

    <div [class.active]="(selectedShippingType$ | async)==shipping.shippingType" class="item" (click)="setShippingType(shipping.shippingType)">
      <i class="fa fa-check check" *ngIf="(selectedShippingType$ | async)==shipping.shippingType"></i>
      <div class="delivery-type-title" *ngIf="shipping.shippingType==1; else ship">
       <!--  <i class="fa fa-plane"></i> -->
       <img src="assets/aereo.svg" style="width: 25px;">
      </div>
      <ng-template #ship>
        <div class="delivery-type-title" else ship>
         <!--  <i class="fa fa-ship"></i> -->
         <img src="assets/maritimo.svg" style="width: 25px;">
        </div>
      </ng-template>
    </div>
  </ng-container>
</div>

